import React from "react"
import { ArrowUpRight, ImageIcon } from "lucide-react"
import { StatusMessage } from "../../ui/StatusMessage"

export const resolveServiceImageUrl = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== "string") {
    return ""
  }

  const trimmedUrl = imageUrl.trim()
  if (
    /^(https?:|data:|blob:)/i.test(trimmedUrl) ||
    trimmedUrl.startsWith("/")
  ) {
    return trimmedUrl
  }

  const apiUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "")
  if (!apiUrl) {
    return `/${trimmedUrl}`
  }

  return `${apiUrl}/${trimmedUrl.replace(/^\//, "")}`
}

const ServicesList = ({
  services = [],
  loading = false,
  error = null,
  onRetry,
  onServiceCardClick,
}) => {
  if (loading) {
    return (
      <StatusMessage
        tone="loading"
        title="Loading services"
        message="We are loading the latest service listings."
      />
    )
  }

  if (error) {
    return (
      <StatusMessage
        tone="error"
        title="Could not load services"
        message={error}
        actionLabel={onRetry ? "Retry" : undefined}
        onAction={onRetry}
      />
    )
  }

  if (services.length === 0) {
    return (
      <StatusMessage
        tone="empty"
        title="No services listed"
        message="There are no active service listings available right now."
      />
    )
  }

  return (
    <div className="tyk-grid">
      {services.map((service) => {
        const serviceImageUrl = resolveServiceImageUrl(service.imageUrl)

        return (
          <button
            key={service.id}
            type="button"
            onClick={() => onServiceCardClick(service)}
            className="card tyk-card flex min-h-[360px] flex-col text-left"
          >
            {serviceImageUrl ? (
              <img
                src={serviceImageUrl}
                alt={service.title}
                className="h-44 w-full object-cover"
              />
            ) : (
              <div className="grid h-44 place-items-center bg-slate-950/40 text-slate-500">
                <ImageIcon size={32} aria-hidden="true" />
              </div>
            )}
            <div className="flex flex-1 flex-col p-5">
              <div className="mb-3 flex items-start justify-between gap-3">
                <h2 className="m-0 text-xl font-bold leading-tight text-slate-50">{service.title}</h2>
                <ArrowUpRight className="mt-1 shrink-0 text-cyan-200" size={18} aria-hidden="true" />
              </div>
              <p className="tyk-clamp-4 text-sm leading-6 text-slate-300">{service.description}</p>
              {service.price && (
                <span className="tyk-pill mt-auto w-fit">Price: {service.price}</span>
              )}
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default ServicesList
